import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from "rxjs";
import { AbstractRESTService } from "./abstract.rest.service";

@Injectable()
export class ElasticRESTService extends AbstractRESTService {
    static readonly TASK_URL = 'ereg/roletype/_search';

    constructor(http: HttpClient) {
        super(http, environment.elasticUrl, null);
    }

    protected createCustomHeaders(): any {
        return {
            headers: new HttpHeaders({
                'Authorization': 'Bearer ' + localStorage.getItem("tokenJWT")
            })
        };
    }
}
